import { Component, forwardRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ISelectOption } from '../base-select/select-option.interface';
import { Observable } from 'rxjs';
import { BaseSelectComponent } from '../base-select/base-select.component';

@Component({
  selector: 'select-remote-base',
  templateUrl: './base-select-remote.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseSelectRemoteComponent),
    multi: true
  } ]
})
export class BaseSelectRemoteComponent extends BaseSelectComponent implements OnChanges {

  @Input() source: Observable<ISelectOption[]>;

  @Input('showEmptyValue') showEmptyValue: boolean = true;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.source && changes.source.currentValue) {
      changes.source.currentValue.subscribe(
        (data: ISelectOption[]) => {
          this.options = data;
        }
      );
    }
  }
}
